import {
    LIST_JUDGES,
    LIST_JUDGES_SUCCESS,
    LIST_JUDGES_ERROR,
    ADD_JUDGES,
    SAVE_JUDGES,
    SAVE_JUDGES_SUCCESS,
    SAVE_JUDGES_ERROR,
    DELETE_JUDGES,
    DELETE_JUDGES_SUCCESS,
    DELETE_JUDGES_ERROR,
    EDIT_JUDGES,
    ENABLE_JUDGES,
    ENABLE_JUDGES_SUCCESS,
    ENABLE_JUDGES_ERROR,
    UPDATE_JUDGES,
    UPDATE_JUDGES_SUCCESS,
    UPDATE_JUDGES_ERROR
} from '../types';

import clienteAxios                                                                 from '../config/axios';
import authToken                                                                    from '../config/token';
import Swal                                                                         from 'sweetalert2';

import { ErrorMessage, SuccessMessage, WaitingMessage }                             from '../components/extras/toastMessages';
import { MSG_CREATE_SUCCESS, MSG_UPDATE_SUCCESS, MSG_DELETING, MSG_DELETE_SUCCESS } from '../constants/messages';
import { METHOD_DISABLED }                                                          from '../constants/requestMethods';

import judgesData                                                                   from '../data/judges';

const controller = 'juez';



//LISTAR JUDGES
export function listJudgesAction(params) {
    return async (dispatch) => {
        //Inicializo
        dispatch( listJudges() );
        //Ejecuto la consulta
        try{
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            //authToken(token);
            //Hago la consulta
            const response = await clienteAxios.get(`/${controller}`, { params });
            //Obtengo los datos
            const judges = response.data;
            //const judges = judgesData;
            //Llamo al dispatch
            dispatch( listJudgesSuccess(judges.content) );
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( listJudgesError(data) );
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const listJudges = () => ({
    type: LIST_JUDGES,
    payload: true
});

const listJudgesSuccess = judges => ({
    type: LIST_JUDGES_SUCCESS,
    payload: judges
});

const listJudgesError = error => ({
    type: LIST_JUDGES_ERROR,
    payload: error
});



//ADD AUDIENCE CATEGORY
export function addJudgesAction(showForm) {
    return (dispatch) => {
        //Inicializo
        dispatch( addJudges(false) );
        //Abro el formulario
        showForm();
    }
}

const addJudges = isEdit => ({
    type: ADD_JUDGES,
    payload: isEdit
});



//SAVE AUDIENCE CATEGORY
export function saveJudgesAction(judge, handleClose) {
    return async (dispatch) => {
        //Inicializo
        dispatch( saveJudges() );
        //Ejecuto la consulta
        try{
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            //authToken(token);
            //Hago la consulta
            const response = await clienteAxios.post(`/${controller}/save`, judge);
            //Obtengo los datos
            //const res = response.data;
            //Llamo al dispatch
            dispatch( saveJudgesSuccess(response.data) );
            //Cierro la ventana
            handleClose();
            //Mensaje
            SuccessMessage(MSG_CREATE_SUCCESS);
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( saveJudgesError(data) );
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const saveJudges = () => ({
    type: SAVE_JUDGES,
    payload: true
});

const saveJudgesSuccess = judge => ({
    type: SAVE_JUDGES_SUCCESS,
    payload: judge
});

const saveJudgesError = error => ({
    type: SAVE_JUDGES_ERROR,
    payload: error
});



//EDIT AUDIENCE CATEGORY
export function editJudgesAction(judge, showForm) {
    return async (dispatch) => {
        //Inicializo
        dispatch( editJudges(judge) );
        //Abro el formulario
        showForm();
    }
}

const editJudges = judge => ({
    type: EDIT_JUDGES,
    payload: judge
});



//ENABLE JUDGES
export function enableJudgesAction(judge) {
    return async (dispatch) => {
        dispatch( enableJudges() );
        try {
            const response = await clienteAxios.put(`/${controller}/${judge.id}/activar`);
            dispatch( enableJudgesSuccess(response.data) );
            SuccessMessage(MSG_UPDATE_SUCCESS);
        }
        catch(error)
        {   const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            if(response)
            {   data = response.data;
            }
            dispatch( enableJudgesError(data) );
            ErrorMessage(data.message);
        }
    }
}

const enableJudges = () => ({
    type: ENABLE_JUDGES,
    payload: true
});

const enableJudgesSuccess = judge => ({
    type: ENABLE_JUDGES_SUCCESS,
    payload: judge
});

const enableJudgesError = error => ({
    type: ENABLE_JUDGES_ERROR,
    payload: error
});



//UPDATE AUDIENCE CATEGORY
export function updateJudgesAction(judge, handleClose) {
    return async (dispatch) => {
        //Inicializo
        dispatch( updateJudges() );
        //Ejecuto la consulta
        try{
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            //authToken(token);
            //Hago la consulta
            const response = await clienteAxios.put(`/${controller}/save/${judge.id}`, judge);
            //Obtengo los datos
            //const res = response.data;
            //Llamo al dispatch
            dispatch( updateJudgesSuccess(response.data) );
            //Cierro la ventana
            handleClose();
            //Mensaje
            SuccessMessage(MSG_UPDATE_SUCCESS);
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( updateJudgesError(data) );
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const updateJudges = () => ({
    type: UPDATE_JUDGES,
    payload: true
});

const updateJudgesSuccess = judge => ({
    type: UPDATE_JUDGES_SUCCESS,
    payload: judge
});

const updateJudgesError = error => ({
    type: UPDATE_JUDGES_ERROR,
    payload: error
});



//DELETE AUDIENCE CATEGORY
export function deleteJudgesAction(judge) {
    return async (dispatch) => {
        //Inicializo
        dispatch( deleteJudges() );
        //Mensaje de Espera
        WaitingMessage(MSG_DELETING);
        //Ejecuto la consulta
        try{
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            //authToken(token);
            //Hago la consulta
            const response = await clienteAxios.put(`/${controller}/${judge.id}/${METHOD_DISABLED}`);
            //Obtengo los datos
            //const res = response.data;
            //Llamo al dispatch
            dispatch( deleteJudgesSuccess(response.data) );
            //Oculto espera
            Swal.close();
            //Mensaje
            SuccessMessage(MSG_DELETE_SUCCESS);
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( deleteJudgesError(data) );
            //Oculto espera
            Swal.close();
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const deleteJudges = () => ({
    type: DELETE_JUDGES,
    payload: true
});

const deleteJudgesSuccess = judge => ({
    type: DELETE_JUDGES_SUCCESS,
    payload: judge
});

const deleteJudgesError = error => ({
    type: DELETE_JUDGES_ERROR,
    payload: error
});